import { render, staticRenderFns } from "./artificialListTwo.vue?vue&type=template&id=5a0e0746&scoped=true&"
import script from "./artificialListTwo.vue?vue&type=script&lang=js&"
export * from "./artificialListTwo.vue?vue&type=script&lang=js&"
import style0 from "./artificialListTwo.vue?vue&type=style&index=0&id=5a0e0746&scoped=true&lang=css&"
import style1 from "./artificialListTwo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0e0746",
  null
  
)

export default component.exports